import Select from 'react-select';

export default function AttendanceClassDateSelector({ classes, selectedClass, setSelectedClass, selectedDate, setSelectedDate, teachers = [] }) {
  const classOptions = classes.map(cls => ({ value: cls.id, label: cls.name }));
  
  // Convert selectedClass to number for comparison since URL params are strings
  const selectedClassId = selectedClass ? Number(selectedClass) : null;
  const selectedOption = classOptions.find(opt => opt.value === selectedClassId) || null;
  
  // Handle special "all" date case
  const isShowingAllDates = selectedDate === 'all';
  const dateValue = isShowingAllDates ? '' : selectedDate;

  return (
    <div className="bg-white rounded-xl p-4 flex flex-col sm:flex-row gap-4 items-center justify-between w-full">
      <div className="flex flex-col gap-1 w-full sm:w-1/2">
        <label className="text-sm font-medium text-slate-700 mb-1">Class</label>
        <Select
          classNamePrefix="react-select"
          options={classOptions}
          value={selectedOption}
          onChange={opt => setSelectedClass(opt ? opt.value : '')}
          placeholder="Select a class..."
          isClearable
          menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
          menuPosition="fixed"
          styles={{
            control: (base) => ({ ...base, minHeight: '42px', borderRadius: '0.5rem', borderColor: '#d1d5db', boxShadow: 'none' }),
            menu: (base) => ({ ...base, zIndex: 9999, borderRadius: '0.75rem' }),
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            option: (base, state) => ({
              ...base,
              fontSize: '1rem',
              fontWeight: 500,
              borderRadius: '0.5rem',
              padding: '0.75rem 1.25rem',
              background: (state.isSelected || state.isFocused)
                ? '#2563eb'
                : 'white',
              color: (state.isSelected || state.isFocused) ? 'white' : '#1e293b',
              cursor: 'pointer',
              transition: 'background 0.2s',
            }),
          }}
        />
      </div>
      <div className="flex flex-col gap-1 w-full sm:w-1/2">
        <label className="text-sm font-medium text-slate-700 mb-1">Date</label>
        <input
          type="date"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
          value={dateValue}
          onChange={e => setSelectedDate(e.target.value)}
          placeholder={isShowingAllDates ? "Showing all dates" : ""}
        />
      </div>
      <div className="flex flex-col gap-1 w-full sm:w-1/2">
        <label className="text-sm font-medium text-slate-700 mb-1">Assigned Instructor</label>
        <div className="flex items-center gap-2 flex-wrap">
          {teachers.length === 0 ? (
            <span className="text-slate-400 text-sm">No teachers</span>
          ) : (
            teachers.map((teacher, idx) => (
              <div key={idx} className="flex items-center gap-1 bg-slate-50 rounded-lg px-2 py-1">
                <img 
                  src={teacher.avatar || teacher.image || `https://ui-avatars.com/api/?name=${encodeURIComponent(teacher.name)}&background=e5e7eb&color=374151&size=28`}
                  alt={teacher.name}
                  className="w-7 h-7 rounded-full object-cover"
                  onError={(e) => {
                    e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(teacher.name)}&background=e5e7eb&color=374151&size=28`;
                  }}
                />
                <span className="text-slate-700 text-sm font-medium">{teacher.name}</span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
} 